module.exports = "/images/alert.svg?5a4511ef339b93ecdae18b5d7671f999";